import React from "react";
import { compose, withAppContext, withActions, withState } from "containers/HOC";
import { Switch } from "react-router-dom";
import ScrollTopRoute from "components/ScrollTopRoute";
import Page from "components/Page";
import PageHead from "components/PageHead";
import ActionLink from "components/ActionLink";
import PageBody from "components/PageBody";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";
import Tabs from "components/new/Tabs";
import TabsItem from "components/new/TabsItem";

import MyOrgUsers from "./MyOrgUsers";
import MyOrgUserInvitations from "./MyOrgUserInvitations";
import MyOrgAnalysisSummary from "./MyOrgAnalysisSummary";
import MyOrgFarmAccessSummary from "./MyOrgFarmAccessSummary";
import MyOrgRenewals from "./MyOrgRenewals";
import MyOrgPayments from "./MyOrgPayments";
import { modal } from "containers/App/_actions";
import { v4 as uuidv4 } from "uuid";
import { getSettings } from "../Datasets/_actions";

class MyOrg extends React.Component {
    componentDidMount() {
        const { refData = {} } = this.props;
        if (refData.deploymentType === "Science") {
            this.props.getSettings(this.props.authContext.accountId);
        }
    }

    inviteNewUser = () => {
        const { account = {} } = this.props;
        const viewModel = {
            existingUsers: account.users,
            invitation: {
                accountId: account.id,
                id: uuidv4(),
            },
        };
        this.props.modal("InviteUserModal", null, viewModel);
    };

    editMyOrg = () => {
        const viewModel = {
            account: {
                id: this.props.authContext.accountId,
                name: this.props.authContext.accountName,
            },
        };
        this.props.modal("OrgDetailsModal", null, viewModel);
    };

    render() {
        const { account, authContext, refData = {}, settings } = this.props;
        const canInvite = authContext.accountType !== "Student";
        const isCommercial = refData.deploymentType === "Commercial";
        const isScience = refData.deploymentType === "Science";
        const numUsers = account && account.users && account.userInvitations ? account.users.length + account.userInvitations.length : 99;

        return (
            <Page>
                <PageHead>
                    <div className="FarmTitle">
                        <div className="FarmTitle-heading">
                            <span className="FarmTitle-name">{account ? account.name : authContext.accountName}</span>
                            <div className="FarmTitle-sub"></div>
                        </div>
                    </div>
                    {authContext.isAdmin && (
                        <div className="PageHead-actions">
                            {canInvite && (!isScience || (settings && numUsers < settings.maxUsers)) && (
                                <ActionLink id="invite-user" className="IconLink--arrow-plus" onClick={this.inviteNewUser}>
                                    Add staff member to organisation
                                </ActionLink>
                            )}
                            {canInvite && isScience && settings && numUsers >= settings.maxUsers && <span className="UnpaidSubscription">You have reached the maximum number of users for your organisation.</span>}
                            <ActionLink id="edit-org" className="IconLink--edit" onClick={this.editMyOrg}>
                                Edit my organisation
                            </ActionLink>
                        </div>
                    )}
                </PageHead>
                <PageBody>
                    <Panel title="My organisation" referrer="/" green>
                        <PanelBody>
                            <Panel>
                                <PanelBody>
                                    <Tabs>
                                        {authContext.isAdmin && <TabsItem id="users-tab" title={account ? `Users (${(account.users || []).length})` : "Users"} to={`/app/myOrg`} exact />}
                                        {authContext.isAdmin && <TabsItem id="user-invitations-tab" title={account ? `User invitations (${(account.userInvitations || []).length})` : "User invitations"} to={`/app/myOrg/invitations`} exact />}
                                        {authContext.isAdmin && false && <TabsItem id="user-summary-tab" title="Analysis summary" to={`/app/myOrg/summary`} exact />}
                                        {isCommercial && <TabsItem id="payments-tab" title="Payment transactions" to={authContext.isAdmin ? "/app/myOrg/payments" : "/app/myOrg"} exact />}
                                        <TabsItem id="farm-access-tab" title="Farm access" to={`/app/myOrg/farmaccess`} exact />
                                        <TabsItem id="recurring-payments" title="Billing" to={`/app/myOrg/renewal`} exact />
                                    </Tabs>
                                    <Switch>
                                        {authContext.isAdmin && <ScrollTopRoute exact path="/app/myOrg" render={(r) => <MyOrgUsers />} />}
                                        {authContext.isAdmin && <ScrollTopRoute exact path="/app/myOrg/invitations" render={(r) => <MyOrgUserInvitations />} />}
                                        {authContext.isAdmin && <ScrollTopRoute exact path="/app/myOrg/summary" render={(r) => <MyOrgAnalysisSummary />} />}
                                        <ScrollTopRoute exact path="/app/myOrg/farmaccess" render={(r) => <MyOrgFarmAccessSummary />} />
                                        <ScrollTopRoute exact path="/app/myOrg/renewal" render={(r) => <MyOrgRenewals />} />
                                        {isCommercial && <ScrollTopRoute exact path={authContext.isAdmin ? "/app/myOrg/payments" : "/app/myOrg"} render={(r) => <MyOrgPayments />} />}
                                    </Switch>
                                </PanelBody>
                            </Panel>
                        </PanelBody>
                    </Panel>
                </PageBody>
            </Page>
        );
    }
}

export default compose(
    withAppContext,
    withActions({ modal, getSettings }),
    withState((state) => {
        return {
            account: state.myOrg.account,
            settings: state.dataset.settings,
        };
    })
)(MyOrg);
